// Import modules first
import { UIManager } from './ui/UIManager'
import { StudentLoginModal } from './ui/StudentLoginModal'
import { ExecutionLogger } from './services/ExecutionLogger'
import { Router } from './router'
import { SampleCodeManager } from './ui/SampleCodeManager'
import 'monaco-editor/min/vs/editor/editor.main.css'
import './styles/animations.css'
import './styles/control-buttons.css'

// ルーティング初期化
const router = new Router()
const routeInfo = router.parseRoute()

// 学生番号チェック
const storedStudentId = StudentLoginModal.getStoredStudentId()

if (!storedStudentId && !router.isDebugMode()) {
  // 学生番号が未入力の場合はモーダル表示
  const modal = new StudentLoginModal((studentId: string) => {
    ExecutionLogger.getInstance().setStudentId(studentId)
    initializeApp()
  })
  modal.show()
} else {
  // すでに学生番号がある場合
  if (storedStudentId) {
    ExecutionLogger.getInstance().setStudentId(storedStudentId)
  }
  initializeApp()
}

function initializeApp() {
  // Initialize UI Manager with route info
  const uiManager = new UIManager(routeInfo)

  // 初期コードを設定
  let initialCode = ''

  if (routeInfo.type === 'sample' && routeInfo.sampleId) {
    // 特定のサンプルコード
    const sample = SampleCodeManager.getSampleById(routeInfo.sampleId)
    if (sample) {
      initialCode = sample.code
    }
  } else if (routeInfo.type === 'default') {
    // デフォルトは空のエディタ
    initialCode = '// ここにCコードを入力してください\n'
  }

  // Set initial code
  if (initialCode) {
    uiManager.setCode(initialCode)
  }
}